import stateByZipCode from "./stateByZipCode";
import { CART_NOT_RESTORED_KEY, ORIGINAL_CART_KEY, RATES_CACHE_KEY } from "./estimatedDeliveryStorageKeys";
import restoreCart from "./restoreCart";


const requestsCache = {};
let ratesCache = {};
const EXPIRY = 1000 * 60 * 60 * 24; // expiry after 1 day

try {
  const cacheString = window.localStorage.getItem(RATES_CACHE_KEY);
  ratesCache = cacheString ? JSON.parse(cacheString) : {};

} catch (error) {
  console.warn('Unable to read delivery cache', error)
}

export default function getShippingDetails({ zip, variantId }) {
  const state = stateByZipCode(zip);

  if (!state) return Promise.resolve(null);

  localStorage.setItem(CART_NOT_RESTORED_KEY, 'true');
  let originalCart = null;
  let rates = null;

  const cacheKey = `${state}-${zip}-${variantId}`;

  if (cacheKey in ratesCache) {
    const { time, rates } = ratesCache[cacheKey];
    if (time && (Date.now() - time) < EXPIRY) {
      return Promise.resolve(rates);
    }
  };

  requestsCache[cacheKey] = fetch(`${window.routes.cart_url}.js`)
    .then(res => res.json())
    // Save all cart items (qty, properties, variant ID, etc)
    .then(cart => {
      originalCart = cart;
      localStorage.setItem(ORIGINAL_CART_KEY, JSON.stringify(originalCart));
      console.log(`saved cart`, cart);
    })
    // Clear cart
    .then(() => {
      console.log(`cleared cart`);
      return fetch(`${window.routes.cart_clear_url}.js`)
    })
    // Add current variant
    .then(() => {
      const data = {
        items: [{
          id: variantId,
          quantity: 1,
        }],
      };

      return fetch(`${window.routes.cart_add_url}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
    })
    // Get shipping rates
    .then(() => {
      return fetch(`${window.routes.cart_url}/shipping_rates.json?shipping_address%5Bzip%5D=${zip}&shipping_address%5Bcountry%5D=US&shipping_address%5Bprovince%5D=${state}`).then(res => res.json());
    })
    .then((ratesRes) => {
      console.log('rates', ratesRes);
      rates = ratesRes;
    })
    // Re-add all items
    .then(() => restoreCart(originalCart))
    .then(cart => {
      window.localStorage.removeItem(CART_NOT_RESTORED_KEY);
      window.localStorage.removeItem(ORIGINAL_CART_KEY);

      console.log('restored cart', cart);
    })
    .catch(() => restoreCart(originalCart).then(() => window.localStorage.removeItem(CART_NOT_RESTORED_KEY)))
    .then(() => {
      ratesCache[cacheKey] = {
        rates,
        time: Date.now(),
      };

      Object.keys(ratesCache).forEach(key => {
        const { time } = ratesCache[key];
        if (time && (Date.now() - time) >= EXPIRY) {
          delete ratesCache[key];
        }
      });
      window.localStorage.setItem(RATES_CACHE_KEY, JSON.stringify(ratesCache));
      return rates;
    });

  return requestsCache[cacheKey];
}
